import { colors } from '@/lib/analytics/colors';
import { SIZE_25 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const storiesReachRateConfig = {
    name: 'kpi.instagram.stories.stories_reach_rate',
    id: 'stories_reach_rate',
    icon: {
        name: 'reach',
        style: colors.yellow
    },
    data_format: KPI_VALUE_PERCENT,
    orientation: ORIENTATION_VERTICAL,
    size: SIZE_25,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
